<template>
  <div class="template">
    <AmendmentsParams />
    <LoaderFullPage v-if="store.loading" />
    <AmendmentsDatas v-else />
  </div>
</template>

<script setup lang="ts">
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import AmendmentsParams from "@follaw-fr/components/amendments/organisms/AmendmentsParams.vue";
import AmendmentsDatas from "@follaw-fr/components/amendments/organisms/AmendmentsDatas.vue";
import {
  useAmendmentsStore,
  useAutoFetchAmendments,
} from "@/follaw-fr/stores/amendments";

const store = useAmendmentsStore();
useAutoFetchAmendments();

store.selectedFilters.from = 0;
</script>
